import { Pipe, PipeTransform } from '@angular/core';
import { Prestation, PrestationType } from 'src/app/shared/models/prestation';

@Pipe({
	name: 'filterPrestationByType'
})
export class FilterPrestationByTypePipe implements PipeTransform {
	transform(prestations: Prestation[], types: PrestationType[]): Prestation[] {
		if (
			prestations === null ||
			types === null ||
			types.length === 0
		) {
			return prestations;
		}
		return prestations.filter(f => types
			.map((f) => f)
			.some((expStr) => expStr.includes(f.typePrestation))
		);
		// return prestations.filter((prestation) => {
		// 	return prestation.type((exp) =>
		// 	types
		// 			.map((exp) => exp)
		// 			.some((expStr) => expStr.includes(exp))
		// 	);
		// });
	}
}
